import { usePopup } from '@contexts/popupContext';
import { APIIntegration, apiConfig } from '@integrations/APIIntegration';
import styles from '@styles/components/QontactPoints/QontactPointNuevo.module.css';
import { useState } from 'react';
import { Application } from '@core/Application';
import { QontactPointsService } from '@services/QontactPointsService';
import { Loader } from '@shared/designSystem/Loader';
import { CoordinatesHelpVideo } from '@components/QontactPoints/CoordinatesHelpVideo';

import { ReactComponent as QontactPointSVG } from '@assets/SVGs/QontactPoint/QontactPointSVG.svg';

const QontactPointNuevo = ({orgID, setClickedScreen}) => {
    const { showPopup, hidePopup } = usePopup()
    const [loading, setLoading] = useState(false)

    const [name, setName] = useState('')
    const [googleInput, setGoogleInput] = useState('')

    const [errors, setErrors] = useState({
        name: '',
        googleInput: ''
    });
    const [wellDone, setWellDone] = useState({
        name: '',
        googleInput: ''
    })


    const createNewQontactPoint = async (name, latitude, longitude) => {
        const qontactPointData = { 
            name: name.trim(), 
            latitude: parseFloat(latitude), 
            longitude: parseFloat(longitude) 
        };
    
        console.log(qontactPointData);
    
        setLoading(true);
        try {  
            const qontactPointsService = new QontactPointsService(Application.shared().coreDependencies.httpClient);
            const responseData = await qontactPointsService.createQontactPoint(orgID, qontactPointData);
            console.log(responseData);

            showPopup(() =>                     
                <div className={styles['popup']} onClick={() => {hidePopup()}}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <circle cx="9" cy="9" r="9" fill="#EC6C56"/>
                        <path d="M12 7L7.875 11L6 9.18182" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <p>Qontact Point guardado</p>
                </div>
            )
            setClickedScreen('listado')
        } catch (error) {  
            console.error(error);
        }
        setLoading(false);
    };
    
    const validateGoogleInput = (value) => {
        function isValidLatLong(str) {
            const regex = /^-?\d{1,2}\.\d{1,15},\s*-?\d{1,3}\.\d{1,15}$/;  
            return regex.test(str);
        }
        if (!isValidLatLong(value)) {
            setErrors(prevErrors => ({
                ...prevErrors, 
                googleInput: 'Coordenadas inválidas'
            }));
            setWellDone({...wellDone, googleInput: ''})
            return false
        } else {
            setErrors(prevErrors => ({
                ...prevErrors, 
                googleInput: ''
            }));
            setWellDone({...wellDone, googleInput: 'Coordenadas válidas'})
            return true
        }
    }

    const validateName = (value) => {
        if (value.trim() === '') {
            setErrors(prevErrors => ({
                ...prevErrors, 
                name: 'Nombre es obligatorio'
            }));
            return false
        } else {
            setErrors(prevErrors => ({
                ...prevErrors, 
                name: ''
            }));
            return true
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        let currentErrors = {
            name: validateName(name),
            googleInput: validateGoogleInput(googleInput)
        }

        if (Object.values(currentErrors).some(succesful => succesful === false)) {
            return;
        }
        let latitude = googleInput.split(',')[0].trim()
        let longitude = googleInput.split(',')[1].trim()
        createNewQontactPoint(name, latitude, longitude)
    }

    const handleCancel = (e) => {
        e.preventDefault();
        setClickedScreen('Listado')
        console.log('cancelled');
    }

    return (
        <div className={styles['main-container']}>
            <div className={styles['nomina-header']}>
                <div className={styles['svg-container']} style={{marginRight: '8px', marginLeft: '15px'}}>
                    <QontactPointSVG/>
                </div>
                <h2 className={styles['title-nomina']}>
                    Agregar Qontact Point
                </h2>
            </div>

            <div className={styles['form-container']}>
                <div className={styles['input-grid']}>
                    <div style={{gridArea: "1 / 1 / 2 / 2", position: 'relative'}}>
                        <p className={styles['input-label-text']}>Nombre Qontact Point</p>
                        <div className={styles['grid-input-container']} style={{marginBottom: '15px'}}>
                            <input 
                            type='text' 
                            placeholder='Nombre Qontact Point' 
                            className={styles['grid-input']}
                            onChange={(e) => {setName(e.target.value)}}
                            value={name}
                            onBlur={(e) => validateName(e.target.value)}
                            />
                        </div>
                        {errors.name && <p className={styles['error-text']}>{errors.name}</p>}
                    </div>

                    <div style={{gridArea: "2 / 1 / 3 / 2", position: 'relative'}}>
                        <p className={styles['input-label-text']}>Latitud y longitud</p>
                        <div className={styles['grid-input-container']} style={{marginBottom: '15px'}}>
                            <input 
                            type='text' 
                            placeholder='Ingresar coordenadas' 
                            className={styles['grid-input']}
                            onChange={(e) => {setGoogleInput(e.target.value)}}
                            value={googleInput}
                            onBlur={(e) => validateGoogleInput(e.target.value)}
                            />
                        </div>
                        {errors.googleInput && <p className={styles['error-text']}>{errors.googleInput}</p>}
                        {wellDone.googleInput && <p className={styles['error-text']} style={{color: '#98ce75'}}>{wellDone.googleInput}</p>}
                    </div>

                    <div style={{gridArea: "2 / 2 / 3 / 3", display: 'flex', width: '100%', height: '100%', justifyContent: 'flex-start', alignItems: 'center'}}>
                        <p className={styles['tutorial-text']} onClick={() => showPopup(() => <CoordinatesHelpVideo />)}>¿Cómo copiar coordenadas desde Google Maps?</p>
                    </div>
                </div>

                <div className={styles['bottom-container']}>
                    <div className={styles['id-container']}>
                        {/* <div className={styles['id-box']}>
                            Noooo estaria entendiendo que es esto
                        </div> */}
                    </div>
                    <div className={styles['buttons-container']}>
                        <div className={`${styles['button']} ${styles['agregar']}`} onClick={handleSubmit}>
                            {!loading ? 'Guardar'
                            :
                            <div className={styles['no-qontact-points']}>
                                <Loader height="32px" width="32px" />
                            </div>
                            }
                        </div>
                        <div className={`${styles['button']} ${styles['cancelar']}`} onClick={handleCancel}>
                            Cancelar
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default QontactPointNuevo
